import { get, post } from '.';

export function GetEnrollerRuns(options = {}) {
	return get<any>("/app/api/enroller_runs", options);
}

export function FindEnrollerRun(vid) {
	return get<any>("/app/api/enroller_runs/" + vid);
}

export function CreateEnrollerRun(options = {}) {
	return post<any>("/app/api/enroller_runs", options);
}